import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "../../components/Button";
import { useTranslations } from "../../providers/useTranslations";
import { SharableLoyaltyProfileDialog } from "./SharableLoyaltyProfileDialog";
export const SharableLoyaltyProfile = ({ userInfo, userId, referralCode, buttonClassName, portalDomNode, }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const { __ } = useTranslations();
    const toggleDialog = () => {
        setIsDialogOpen((prev) => !prev);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: toggleDialog, color: "primary", "data-testid": "openSharableLoyaltyProfileDialog", className: buttonClassName, children: __("profile.personal_details.sharable_loyalty_profile.button_label") }), _jsx(SharableLoyaltyProfileDialog, { userInfo: userInfo, userId: userId, referralCode: referralCode, isOpened: isDialogOpen, onClose: toggleDialog, portalDomNode: portalDomNode })] }));
};
//# sourceMappingURL=SharableLoyaltyProfile.js.map